// SHARED-011: Settlement calculation formulas

import type {
  ContractResult,
  BattleResult,
  MaintenanceResult,
  SettlementResult,
  EconomyDelta,
} from '@/shared/types/phase-contracts';
import { usePlayerStore } from '@/shared/stores/playerStore';

export function calculateSettlement(
  contractResult: ContractResult,
  battleResult: BattleResult,
  maintenanceResult: MaintenanceResult,
): SettlementResult {
  const { project } = contractResult;
  const scope = project.scope;

  if (battleResult.battleOutcome === 'VICTORY') {
    const baseReputation = scope + 3;
    const maintenanceBonus = maintenanceResult.outcome === 'VICTORY' ? 2 : 0;
    return {
      economyDelta: {
        flopChange: project.completionBonus + (maintenanceResult.moneyEarned || 0),
        agiChange: scope * 5,
        reputationChange: baseReputation + maintenanceBonus,
      },
    };
  } else {
    return {
      economyDelta: {
        flopChange: Math.floor(project.completionBonus * 0.3) + (maintenanceResult.moneyEarned || 0),
        agiChange: 0,
        reputationChange: -(scope - 1),
      },
    };
  }
}

/**
 * 将结算经济增量应用到 playerStore。
 * 在 Phaser scene 回调等非 React 上下文中通过 getState() 直接调用。
 */
export function applySettlementToPlayer(economyDelta: EconomyDelta): void {
  const store = usePlayerStore.getState();

  // FLOP
  if (economyDelta.flopChange > 0) {
    store.addFlop(economyDelta.flopChange);
  } else if (economyDelta.flopChange < 0) {
    const success = store.spendFlop(Math.abs(economyDelta.flopChange));
    if (!success) {
      // 余额不足：将 flop 全部扣除（设为 0）
      const current = usePlayerStore.getState().flop;
      if (current > 0) {
        store.spendFlop(current);
      }
    }
  }

  // AGI
  if (economyDelta.agiChange > 0) {
    store.addAGI(economyDelta.agiChange);
  }

  // Reputation
  if (economyDelta.reputationChange !== 0) {
    store.addReputation(economyDelta.reputationChange);
  }

  // 项目完成计数
  store.incrementCompletedProjects();
}
